import React from "react";
import { Link } from "react-router-dom";

const styles = {
  backLink: {
    display: "block",
    marginTop: "20px",
    textAlign: "center",
    textDecoration: "none",
    color: "#007bff",
    fontSize: "18px",
  }
};

const teams = [
  {
    name: "Team 1 - Juluk Sengel",
    members: [
      { name: "ACHAL TIGGA", batch: "2K12" },
      { name: "ANUPAMA MURMU", batch: "2K21" },
	    { name: "ARCHANA KHALKHO", batch: "2K1" },
	    { name: "ARNAV MUNDA", batch: "2K16" },
      { name: "BINOD TOPPO", batch: "1999" },
      { name: "DEEPAK SOREN", batch: "2K16" },
      { name: "HARI HANS HANSDAH", batch: "2K20" },
      { name: "NIKHIL SINGH", batch: "2K5" },
	    { name: "PRAVEEN KUMAR", batch: "2K4"},
      { name: "KARAMCHAND TIRKEY", batch: "2K3" },
      { name: "PUSHKAR KHAKHA", batch: "2K1" },
      { name: "RAJARSHI HASDAH", batch: "2K3" },
      { name: "REMISH LEONARD MINZ", batch: "2K4" },
      { name: "SANTOSH ORAON", batch: "2K21" },
      { name: "SUBHASH KUMAR ASUR", batch: "2K24" },
      { name: "SUNIL KUMAR XALXO", batch: "2K1" },
      { name: "SWAPNIL ANUBHAV XALXO", batch: "2K16" },
    ],
  },
  {
    name: "Team 2 - Tribal Tempest",
    members: [
      { name: "MRINAL HANSDAH", batch: "2K12" },
      { name: "AKASH TIGGA", batch: "2K20" },
      { name: "AYUSH BARAIK", batch: "2K23" },
      { name: "ANOOP KANDULNA", batch: "2K5" },
      { name: "ARUN TIRKEY", batch: "2K2" },
      { name: "BHASKAR LAKRA", batch: "2K5" },
      { name: "CECIL TOPNO", batch: "2K1" },
      { name: "JOSHUA VINCENT TOPPO", batch: "2K" },
      { name: "PARMESHWAR SINGH", batch: "2K24" },
	    { name: "PREETI KERKETTA", batch: "2K6"},
      { name: "SANDEEP DHEERAJ KINDO", batch: "2K3" },
      { name: "JAGNATH TUTI", batch: "2K3" },
      { name: "PRIYANKA PRIYADARSHINI", batch: "2K6" },
      { name: "MOHIT TOPPO", batch: "2K16" },
      { name: "VIVEK ANAND BASKEY", batch: "2K2" },
      { name: "VINAY MARANDI", batch: "2K21" },
	    { name: "VISHAL VIVEK TOPNO", batch: "2K2" },
    ],
  },
  {
    name: "Team 3 - Tribal Legion",
    members: [
      { name: "MANISHA ORAON", batch: "2K24" },
	    { name: "ARCHANA KERKETTA", batch: "2K16" }, 
	    { name: "HIMANSHU KUMAR", batch: "2K22" },
      { name: "MICHRAI PURTY", batch: "2K24" },
      { name: "JOHN TOPNO", batch: "1996" },
      { name: "MANOHAR BEDIYA", batch: "2K19" },
      { name: "RITESH BARA", batch: "2K" },
      { name: "VASANT SAMIR MINJ", batch: "2K2" },
      { name: "AUGUSTINE GURIA", batch: "2K2" },
      { name: "SUMIT TOPPO", batch: "2K19" },
      { name: "NITIN TIGGA", batch: "2K2" },
      { name: "RAJAT MARCEL BECK", batch: "2K11" },
      { name: "VIVEK SINGH KUNTIA", batch: "2K3" },
      { name: "ANURAG HERENJ", batch: "2K20" },
      { name: "AVINASH KUMAR LAKRA", batch: "2K20" },
      { name: "MANOJ KANDEYANG", batch: "2K2" },
      { name: "SACHIN TIRKEY", batch: "2K12" },
    ],
  },
  {
    name: "Team 4 - Chotanagpur Warriors",
     members: [
      {name: "RAHUL HEMBROM", batch: "2K22"},
      {name: "ARVIND BHAGAT", batch: "2K22"},
      {name: "ANILA SMRITI SURIN", batch: "2K5"},
      {name: "CHANDRASEN GURIA", batch: "2K4"},
      {name: "JOY JAYANT BECK", batch: "2K4"},
      {name: "ABHISHEK MINZ", batch: "2K2"},
      {name: "ANURAG KHESS", batch: "2K16"},
      {name: "SHAHIL EKKA", batch: "2K20"},
      {name: "RAJNISH KACHHAP", batch: "2K5"},
      {name: "UDIT KACHHAP", batch: "2K20"},
      {name: "AMIT", batch: "2K2"},
      {name: "APURB NITESH TIGGA", batch: "2K5"},
      {name: "NAMAN PRIYESH LAKRA", batch: "2K6"},
      {name: "SMITA HORO", batch: "2K3"},
	     { name: " KRIPA NIDHI DUNGDUNG", batch: "2K24"},
	     
      {name: "NITESH PAUL NAG", batch: "1999"},
    ],
  },
];

const TeamDistribution = () => {
  return (
    <div style={{ padding: "20px" }}>
      <h1>Team Distribution</h1>
      {teams.map((team, index) => (
        <div key={index} style={{ marginBottom: "30px" }}>
          <h2>{team.name}</h2>
          <table border="1" cellPadding="5" cellSpacing="0">
            <thead>
              <tr>
                <th>Name</th>
                <th>Batch</th>
              </tr>
            </thead>
            <tbody>
              {team.members.map((member, idx) => (
                <tr key={idx}>
                  <td>{member.name}</td>
                  <td>{member.batch}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      ))}
      <Link to="/" style={styles.backLink}>Back to Leaderboard</Link>
    </div>
  );
};

export default TeamDistribution;

